import NavHelp from "@/components/navbar/nav-help";
import { NavMain } from "@/components/navbar/nav-main";
import NavTeamSwitcher from "@/components/navbar/nav-team-switcher";
import { useContext, useEffect } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import ShaarpLogoWhite from "./assets/shaarp-logo-main-light.svg";
import ShaarpLogo from "./assets/shaarp-logo-main.svg";
import NavTeamPaymentWarning from "./components/navbar/nav-team-payment-warning";
import NavTeamTrial from "./components/navbar/nav-team-trial";
import { NavUserDropdown } from "./components/navbar/user-nav-dropdown";
import { Badge } from "./components/ui/badge";
import { ThemeProviderContext } from "./contexts/theme-provider";
import { resetWindowTitle } from "./lib/window-title";

export type LayoutDesktopProps = {
  showNavMain?: boolean;
  showTeamSwitcher?: boolean;
  showTeamTrial?: boolean;
  navLinkToTheRoot?: boolean;
  children?: React.ReactNode;
};

export default function LayoutDesktop({
  showNavMain = true,
  showTeamSwitcher = true,
  showTeamTrial = true,
  navLinkToTheRoot = true,
  children,
}: LayoutDesktopProps) {
  const { isLightTheme } = useContext(ThemeProviderContext);
  const location = useLocation();

  useEffect(() => {
    resetWindowTitle();
  }, [location]);

  return (
    <>
      <div className="flex flex-col">
        <div className="fixed top-0 right-0 left-0 z-10 w-full bg-background">
          <div className="absolute -bottom-px left-0 right-0 h-[4px] bg-gradient-1 z-11"></div>
          <div className="flex items-center px-4 h-(--app-header-height)">
            {navLinkToTheRoot ? (
              <NavLink to="/" className="mx-2">
                <img
                  src={isLightTheme ? ShaarpLogo : ShaarpLogoWhite}
                  alt="Shaarp"
                  className="h-12"
                />
              </NavLink>
            ) : (
              <div className="mx-2">
                <img
                  src={isLightTheme ? ShaarpLogo : ShaarpLogoWhite}
                  alt="Shaarp"
                  className="h-12"
                />
              </div>
            )}
            {import.meta.env.VITE_APP_ENV &&
              import.meta.env.VITE_APP_ENV !== "production" && (
                <Badge variant="outline" className="ml-2">
                  {import.meta.env.VITE_APP_ENV.toUpperCase()}
                </Badge>
              )}
            {showNavMain && <NavMain className="mx-6" />}

            <div className="flex items-center ml-auto space-x-4">
              {showTeamSwitcher && <NavTeamSwitcher />}
              {showTeamTrial && <NavTeamTrial />}
              <NavTeamPaymentWarning />
              <NavHelp />
              <NavUserDropdown />
            </div>
          </div>
        </div>
        <div className="fixed top-0 pt-[calc(var(--app-header-height)+1px)] left-0 w-full h-screen overflow-auto">
          {children ? children : <Outlet />}
        </div>
      </div>
    </>
  );
}
